import { getLink } from "../../../../utils/utils";

import translator from "../translator";


const content = {
  esp: (
    `
    <p class="mb-3">
      La Lignofajro estingiĝis. 
      Apenaŭ restis en li vivo; li sentis, ke maksimume post duonhoro restos de li nur manpleno de cindro, kaj nenio plu. 
      Eta cindra amaseto ene de grandega majesta arbaro.
    </p>
    
    <p class="mb-3">
      La Lignofajro feble kraketis, vokante helpon. 
      Lia ruĝa langeto febre lekis la nigriĝantan braĝon, kaj la preterkuranta Rojo afable proponis:
    </p>
    
    <p class="mb-3">
      - Ĉu akvon?
    </p>
    
    <p class="mb-3">
      La Lignofajro eksiblis pro senpova kolero. 
      Nur akvo al li mankis! 
      Kompreninte la sentaktecon de sia demando, la Rojo lirlis malvarmajn pardonpetojn kaj daŭrigis sian vojon.
    </p>
    
    <p class="mb-3">
      Sed tiam super la mortanta Fajro sin klinis Arbustoj. 
      Senvorte ili etendis al li siajn branĉojn.
    </p>
    
    <p class="mb-3">
      La Lignofajro avide kaptis ilin, kaj okazis miraklo: la flamo, ŝajne jam pereinta, ekflamis denove!
    </p>
    
    <p class="mb-3">
      Jen kion signifas etendita ĝustatempe helpa brako!
    </p>
    
    <p class="mb-3">
      La Lignofajro ekstaris, apoginte sin je la Arbustoj, kaj evidentiĝis, ke li tute ne estas tia senhelpa kaj eta. 
      La Arbustoj sin skuis kaj dronis en plena flamo. Kaj la Rojo sekiĝis. 
      Ne estis iu por savi ilin.
    </p>
    
    <p class="mb-3">
      Kaj la Lignofajro jam impetis supren. 
      Li fariĝis tiom alta kaj arda, ke eĉ la Arboj sin tiris al li; - iuj allogitaj de lia beleco, aliuj simple por varmigi sin.
    </p>
    
    <p class="mb-3">
      La foraj Arboj enviis al tiuj, kiuj situis pli proksime, kaj nur revis alproksimiĝi al la fonto de entuziasmo kaj adoro.
    </p>
    
    <p class="mb-3">
      La Fajro! Fajro! Nia Fajro! – bruis malproksimaj Arboj. 
      – Li varmigas nin, li prilumas nian vivon!
    </p>
    
    <p class="mb-3">
      La proksimaj Arboj bruis eĉ pli laŭte. 
      Ne pro admiro, - sed ĉar la Fajro devoris ilin en sia flamo, faligis, por mem supreniĝi pli kaj pli alten. 
      Kiu ja povas kontraŭstari la sovaĝan potencegon de giganta Fajro en arbaro?
    </p>
    
    <p class="mb-3">
      Troviĝis tamen la forto, kiu estingis la Fajron. 
      Venis la fulmotondro, kaj la Arboj ploris per nigraj larmoj – larmoj pro la Fajro, kiu tiel brilegis kaj kiu pro inundo ne sukcesis devori ilin.
    </p>
    
    <p class="mb-3">
      Nur poste, sufiĉe poste, kiam sekiĝis fulgaj larmoj, la Arboj ekvidis grandegan nigran cindrejon sur la loko, kie furiozis la Lignofajro.
    </p>
    
    <p class="mb-3">
      Ne, ne la Lignofajro – la Incendio. 
      Arbara Fajrego. 
      Terura kataklismo.
    </p>
    `
  )
}

const itemName = {
  esp: 'La lignofajro enarbara'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;